import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsRetrieveTagBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Retrieve tag</div>
          <div className="text">Retrieves the details of an existing tag, specified by its id.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The tag's unique identifier.",
                heading: 'id',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns a tag object, if a valid id was supplied.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/tags/retrieve</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/tags/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d id=553c3ef8b8cdcd1501ba12bb`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba12bb",
  "board": {
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba4400",
    "name": "Feature Requests",
    "postCount": 99,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "created": "2017-08-30T13:32:01.000Z",
  "name": "Example Tag Name",
  "postCount": 12,
  "url": "https://your-company.canny.io/admin/board/feature-requests?tag=example-tag-name"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
